import { useDispatch, useSelector } from "react-redux";
import React, { useEffect, useMemo, useRef, useState } from "react";
import {
  deleteOrganisationDepartment,
  deleteOrganisationDepartmentSuccess,
  getOrganisationDepartmentData,
  getOrganisationDepartmentList,
  getOrganisationDepartmentToStaffList,
  deleteOrganisationDepartmentToStaff,
  deleteOrganisationDepartmentToStaffSuccess,
} from "../../../../../store/staff/action";
import Staff from "../../../../../store/staff/reducer";
import LocalDataSearch from "../../../../../Components/SearchAndFilter";
import LoadingSpinner from "../../../../../Components/Common/Spinner";
import TableContainer from "../../../../../Components/Common/TableContainer";
import { Link } from "react-router-dom";
import {
  Col,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Input,
  Row,
  UncontrolledDropdown,
} from "reactstrap";
import { isEmpty } from "lodash";
import HandleDateTime from "../../../../../Components/Common/HandleDateTime";
import CreateEditDepartment from "../../../../../Components/popUpComponents/CreateEditDepartment";
import CreateEditDepartmentToStaff from "../../../../../Components/popUpComponents/CreateEditDepartmentToStaff";
import InfoCard from "../../../../../Components/Common/InfoCard/InfoCard";
import { parentIdOf } from "../departmentHierarchy";
import DeleteModal from "../../../../../Components/Common/DeleteModal";
import { toast } from "react-toastify";

const DepartmentsSettings = ({ setSelectedDepartment, setActiveTab }) => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getOrganisationDepartmentList());
    // Task 24459 - the side panel reads assignments from this list.
    dispatch(getOrganisationDepartmentToStaffList());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Task 24459 - the department whose people are shown in the side panel.
  // Clicking a row used to throw you onto a different tab; now it just fills
  // the panel next to the list, so you keep your place.
  const [panelDepartmentId, setPanelDepartmentId] = useState(null);
  const [assignModal, setAssignModal] = useState(false);

  const { departmentToStaffListAPI } = useSelector((state) => ({
    departmentToStaffListAPI:
      state.Staff.organisationDepartmentToStaffList
        ?.organisationdepartmenttostaff_list,
  }));

  const { deleteDepartmentToStaffSuccessAPI } = useSelector((state) => ({
    deleteDepartmentToStaffSuccessAPI:
      state.Staff.deleteOrganisationDepartmentToStaffSuccess,
  }));

  useEffect(() => {
    if (isEmpty(deleteDepartmentToStaffSuccessAPI)) return;
    if (deleteDepartmentToStaffSuccessAPI?.status === 200) {
      toast.success(deleteDepartmentToStaffSuccessAPI?.message);
      dispatch(getOrganisationDepartmentToStaffList());
    } else {
      toast.error(deleteDepartmentToStaffSuccessAPI?.message);
    }
    dispatch(deleteOrganisationDepartmentToStaffSuccess([]));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [deleteDepartmentToStaffSuccessAPI]);

  // Refresh the panel whenever the assign dialog closes.
  const assignWasOpen = useRef(false);
  useEffect(() => {
    if (assignWasOpen.current && !assignModal) {
      dispatch(getOrganisationDepartmentToStaffList());
    }
    assignWasOpen.current = assignModal;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [assignModal]);

  const { organisationDepartmentListAPI, loadingOrganisationDepartmentList } =
    useSelector((state) => ({
      organisationDepartmentListAPI:
        state.Staff.organisationDepartmentList?.organisationdepartment_list,
      loadingOrganisationDepartmentList:
        state.Staff.loadingOrganisationDepartmentList,
    }));
  console.log("organisationDepartmentListAPI", organisationDepartmentListAPI);
  const [allowedSearchFilters, setAllowedSearchFilters] = useState([
    "Id",
    "Name",
    "Staff_FullName",
    "JobStatus_Name",
    "Customer_FullName",
    "CustomerReference",
  ]);

  const allowedFiltersInit = [
    {
      useThisFilter: true,
      filterTitle: "Created Date Range",
      filterType: "DateRange",
      filterProperty: "CreatedDateTime",
      filterValue: {
        startDate: "",
        endDate: "",
      },
    },
  ];
  const [allowedFilters, setAllowedFilters] = useState(allowedFiltersInit);
  const [showFilter, setShowFilter] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [searchData, setSearchData] = useState([]);
  const [searchInActionShowLoading, setSearchInActionShowLoading] =
    useState(false);
  const toggleShowFilter = () => {
    setShowFilter(!showFilter);
  };

  const columns = useMemo(
    () => [
      {
        // job id  with beginning #Job_Id
        Header: "Id",
        accessor: "Id",
        filterable: false,
        Cell: (jobs) => (
          <>
            <div className="d-flex align-items-center">
              <div
                className="flex-grow-1 ms-2 name like-href"
                onClick={() => setPanelDepartmentId(jobs.row.original?.Id)}
              >
                <span className={"like-href"}> #{jobs.row.original.Id}</span>
              </div>
            </div>
          </>
        ),
      },
      {
        Header: "Department Name",
        accessor: "Name",
        filterable: true,
        Cell: (jobs) => (
          <>
            <div
              onClick={() => setPanelDepartmentId(jobs.row.original?.Id)}
              className="d-flex align-items-center like-href"
            >
              <div className="flex-grow-1 ms-2 name">
                {jobs.row.original?.CssColourBackground &&
                jobs.row.original?.CssColourText ? (
                  <span
                    className="badge d-inline-flex align-items-center"
                    style={{
                      background: jobs.row.original.CssColourBackground,
                      color: jobs.row.original.CssColourText,
                    }}
                  >
                    <i className="ri-team-line me-1" />
                    {jobs.row.original?.Name}
                  </span>
                ) : (
                  jobs.row.original?.Name
                )}
              </div>
            </div>
          </>
        ),
      },

      {
        // Task 24460 - the hierarchy was invisible here: a sub-department
        // looked identical to a top-level one. The list already carries
        // Parent___OrganisationDepartmentHierarchy_Id, so the name is resolved
        // from the rows we already have rather than a self-join in the API.
        Header: "Parent Department",
        accessor: "Parent___OrganisationDepartmentHierarchy_Id",
        filterable: false,
        Cell: (cell) => {
          // Task 24468 - "0" arrives as a string and is truthy, so a plain
          // falsy check let a top-level department fall through to the lookup
          // and render "#0".
          const parentId = parentIdOf(cell.row.original);
          if (!parentId) {
            return (
              <span className="badge bg-success-subtle text-success">
                No parent
              </span>
            );
          }
          const parent = (organisationDepartmentListAPI || []).find(
            (d) => String(d.Id) === String(parentId)
          );
          return (
            <span className="d-inline-flex align-items-center">
              <i className="ri-corner-down-right-line text-muted me-1" />
              {parent?.Name || `#${parentId}`}
            </span>
          );
        },
      },
      {
        Header: "Create On",
        accessor: (row) => {
          //CreatedDateTime sort date so its day Month name Year and time

          return <div>{HandleDateTime(row?.CreatedDateTime)}</div>;

          // return row.CreatedDateTime
        },
        filterable: false,
      },
      {
        Header: "Action",
        Cell: (cellProps) => {
          return (
            <UncontrolledDropdown>
              <DropdownToggle
                className="btn btn-soft-info btn-icon fs-14"
                type="button"
                id="dropdownMenuButton1"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <i className="fa-solid fa-ellipsis"></i>
              </DropdownToggle>
              <DropdownMenu>
                <li>
                  <DropdownItem>
                    <div
                      className="edit-item-btn"
                      onClick={() => {
                        // Task 24459 - this used to throw you onto the
                        // Department Details tab. The side panel answers the
                        // same question without losing your place in the list.
                        dispatch(getOrganisationDepartmentToStaffList());
                        setPanelDepartmentId(cellProps.row.original?.Id);
                      }}
                    >
                      <div className={"job-settings-buttons"}>
                        <i className="fa-solid fa-users-viewfinder text-muted me-1"></i>

                        <span> See assigned staff</span>
                      </div>
                    </div>
                  </DropdownItem>
                  <DropdownItem>
                    <div
                      className="edit-item-btn"
                      onClick={() => {
                        handleUpdate(cellProps.row.original.Id);
                      }}
                    >
                      <div className={"job-settings-buttons"}>
                        <i className="ri-pencil-fill align-center text-muted me-1"></i>
                        <span> Edit</span>
                      </div>
                    </div>
                  </DropdownItem>
                </li>

                <li>
                  <DropdownItem>
                    <div
                      className="remove-item-btn"
                      onClick={() => {
                        handlePreDelete(cellProps.row.original.Id);
                      }}
                    >
                      <div className={"job-settings-buttons"}>
                        <i className="ri-delete-bin-fill align-center text-muted me-1"></i>{" "}
                        <span> Delete</span>
                      </div>
                    </div>
                  </DropdownItem>
                </li>
              </DropdownMenu>
            </UncontrolledDropdown>
          );
        },
      },
    ],
    // organisationDepartmentListAPI feeds the parent-name lookup; without it
    // the Parent Department column renders against a stale list.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [searchData, organisationDepartmentListAPI]
  );
  const [modal, setModal] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const { singleOrganisationDepartmentDataAPI } = useSelector((state) => ({
    singleOrganisationDepartmentDataAPI:
      state.Staff.singleOrganisationDepartmentData?.organisationdepartment_data,
  }));

  const toggle = () => {
    setModal(!modal);
  };

  const handleUpdate = (id) => {
    setIsEdit(true);
    setModal(true);
    dispatch(getOrganisationDepartmentData({ id }));
  };
  const [deleteModal, setDeleteModal] = useState(false);
  const [itemToBeDeleted, setItemToBeDeleted] = useState(null);
  const handlePreDelete = (id) => {
    setDeleteModal(true);
    setItemToBeDeleted([id]);
  };

  const panelDepartment = (organisationDepartmentListAPI || []).find(
    (d) => String(d.Id) === String(panelDepartmentId)
  );
  const panelStaff = (departmentToStaffListAPI || []).filter(
    (row) =>
      String(row?.OrganisationDepartment_Id) === String(panelDepartmentId)
  );

  const executeDelete = () => {
    dispatch(deleteOrganisationDepartment(itemToBeDeleted));
  };
  const { deleteOrganisationDepartmentSuccessAPI } = useSelector((state) => ({
    deleteOrganisationDepartmentSuccessAPI:
      state.Staff.deleteOrganisationDepartmentSuccess,
  }));

  useEffect(() => {
    if (isEmpty(deleteOrganisationDepartmentSuccessAPI)) return;
    if (deleteOrganisationDepartmentSuccessAPI?.status === 200) {
      toast.success(deleteOrganisationDepartmentSuccessAPI?.message);
      dispatch(getOrganisationDepartmentList());
      setDeleteModal(false);
      setItemToBeDeleted(null);
    } else {
      toast.error(deleteOrganisationDepartmentSuccessAPI?.message);
    }
    dispatch(deleteOrganisationDepartmentSuccess([]));
  }, [deleteOrganisationDepartmentSuccessAPI]);
  return (
    <div>
      {deleteModal && (
        <DeleteModal
          show={deleteModal}
          onDeleteClick={executeDelete}
          onCloseClick={() => setDeleteModal(false)}
        />
      )}
      {assignModal && (
        <CreateEditDepartmentToStaff
          modal={assignModal}
          setModal={setAssignModal}
          toggle={() => setAssignModal(!assignModal)}
          isEdit={false}
          preselectedDepartmentId={panelDepartmentId}
        />
      )}
      {modal && (
        <CreateEditDepartment
          modal={modal}
          setModal={setModal}
          toggle={toggle}
          isEdit={isEdit}
          updateData={singleOrganisationDepartmentDataAPI}
        />
      )}
      <LocalDataSearch
        Page={""}
        ReceivedDataAPI={organisationDepartmentListAPI}
        setSearchInActionShowLoading={setSearchInActionShowLoading}
        allowedSearchFilters={allowedSearchFilters}
        searchQuery={searchQuery}
        setSearchFilteredResults={setSearchData}
        showFilter={showFilter}
        setShowFilter={setShowFilter}
        toggleShowFilter={toggleShowFilter}
        allowedFiltersInit={allowedFiltersInit}
        allowedFilters={allowedFilters}
        setAllowedFilters={setAllowedFilters}
      />
      <div>
        <div className={"p-2"}>
          <Row className="g-4 align-items-center">
            <Col sm={4}>
              <div className={"d-flex"}>
                <div className="search-box">
                  <Input
                    // create search with jobs List Data
                    type="search"
                    className="form-control search"
                    placeholder="Search for..."
                    onChange={(e) => {
                      setSearchQuery(e.target.value);
                    }}
                    value={searchQuery}
                  />
                  <i className="ri-search-line search-icon"></i>
                </div>
              </div>
            </Col>
            <div className="col-sm-auto ms-auto">
              <div className="hstack gap-2">
                <button
                  type="button"
                  className="btn btn-info btn-info-filters"
                  onClick={() => toggleShowFilter()}
                >
                  <i className="ri-filter-3-line align-bottom me-1"></i> Filters
                </button>
                <button
                  type="button"
                  className="btn btn-success add-btn btn-info-add-jobs"
                  id="create-btn"
                  onClick={() => {
                    setIsEdit(false);
                    toggle();
                  }}
                >
                  <i className="ri-add-line align-bottom me-1"></i>
                  New Department
                </button>
              </div>
            </div>
          </Row>
          {loadingOrganisationDepartmentList ? (
            <LoadingSpinner />
          ) : (
            <Row className="g-3">
              <Col lg={panelDepartmentId ? 8 : 12}>
                {searchData?.length > 0 ? (
                  <TableContainer
                    columns={columns}
                    data={searchData}
                    isGlobalFilter={false}
                    isAddUserList={false}
                    customPageSize={10}
                    className="custom-header-css"
                    divClass="table-responsive table-card mb-0"
                    tableClass="align-middle table-wrapper-scroll-y my-custom-scrollbar"
                    theadClass="text-muted"
                    isLeadsFilter={false}
                  />
                ) : (
                  <div>
                    <div className="text-center">
                      <h2>No results</h2>
                      <p className="text-muted">
                        There are no data available or try new search query.
                      </p>
                    </div>
                  </div>
                )}
              </Col>

              {/* Task 24459 - who is actually in this department, beside the
                  list rather than a tab away. */}
              {panelDepartmentId && (
                <Col lg={4}>
                  <InfoCard
                    title={panelDepartment?.Name || "Department"}
                    icon="ri-team-line"
                    accent="indigo"
                    actions={
                      <button
                        type="button"
                        className="single-shell-card-btn"
                        title="Close this panel"
                        onClick={() => setPanelDepartmentId(null)}
                      >
                        <i className="ri-close-line" />
                        Close
                      </button>
                    }
                  >
                    <div className="d-flex justify-content-between align-items-center mb-2">
                      <span className="text-muted small">
                        {panelStaff.length} assigned
                      </span>
                      <button
                        type="button"
                        className="btn btn-sm btn-success"
                        onClick={() => setAssignModal(true)}
                      >
                        <i className="ri-user-add-line align-bottom me-1" />
                        Assign staff
                      </button>
                    </div>

                    {isEmpty(panelStaff) ? (
                      <p className="text-muted mb-0">
                        Nobody is in this department yet.
                      </p>
                    ) : (
                      <div className="d-flex flex-column gap-2">
                        {panelStaff.map((row) => (
                          <div
                            key={row.Id}
                            className="d-flex align-items-center gap-2 border-bottom pb-2"
                          >
                            <div className="flex-grow-1 min-w-0">
                              <div className="fw-semibold text-truncate">
                                {/* Change #100318 - opens the staff profile. */}
                                <Link
                                  to={`/staff-details/${row.Staff_Id}/Overview`}
                                  title="Open staff profile"
                                >
                                  {row.Staff_FullName ||
                                    [row.Staff_FirstName, row.Staff_LastName]
                                      .filter(Boolean)
                                      .join(" ")}
                                </Link>
                                {String(row.FlagManager) === "1" && (
                                  <span className="badge bg-info-subtle text-info ms-1">
                                    Manager
                                  </span>
                                )}
                              </div>
                              {row.Staff_JobTitle && (
                                <div className="text-muted small text-truncate">
                                  {row.Staff_JobTitle}
                                </div>
                              )}
                            </div>
                            <button
                              type="button"
                              className="btn btn-sm btn-outline-danger"
                              title="Remove from this department"
                              onClick={() =>
                                dispatch(
                                  deleteOrganisationDepartmentToStaff([row.Id])
                                )
                              }
                            >
                              <i className="ri-delete-bin-line" />
                            </button>
                          </div>
                        ))}
                      </div>
                    )}
                  </InfoCard>
                </Col>
              )}
            </Row>
          )}
        </div>
      </div>
    </div>
  );
};

export default DepartmentsSettings;
